import { GET_WIDGET_WALL_DATA,APPS_MORE_BANNER_DETAIL, USER_TYPE } from "../reducers/keys";
import store from "../store";
import { updateTheme } from "./appsMoreAction";
import { toggleAddFeedsSection_D } from "./showDisplayModalAction";
import { WALLS_DETAILS, SOCIAL_WALL_STATUS, SWITCH_THEME_UPDATE } from "./api";
import HttpClient from "./http-client";
import { checkLoginToken, getUserTags } from "./loginActions";


export function getWidgetWallData(ownerId,wallId,callback=null){ 
    let wallID = wallId;

    if((wallId && isNaN(wallId)) || wallId == null){
        const paths = window.location.pathname.split('/');
        wallID = paths.includes('analytic') ? paths[3] : paths[4];
    }
    localStorage.setItem('wallId',wallID);
    return (dispatch) => {

        return new HttpClient().post(`${WALLS_DETAILS }`, { wallId: Number(wallID)}).then((response) => {
                const { userTags } = store.getState().authenticated;
                if(response.data && Object.keys(response.data).length>0){                    
                    dispatch({ type: GET_WIDGET_WALL_DATA, payload: response.data});
                    dispatch({ type: APPS_MORE_BANNER_DETAIL, payload: response.data});
                    if (!userTags) {
                        dispatch(getUserTags(localStorage.getItem('ownerId')));
                    }

                    if(callback){
                        callback()
                        dispatch(toggleAddFeedsSection_D(true))
                    }
                }
            }).catch((error) => {
                checkLoginToken(error);
            });
    };
}


export const userStatus = (e) =>{

    return (dispatch) =>{
        new HttpClient().post(SOCIAL_WALL_STATUS, e).then((response)=>{
            const { data } = response
            if(data.responseCode==200){ 
                dispatch({ type: USER_TYPE, payload:  e.status });
            }
        }).catch(ex=>{});
    }
}

export const checkTheme = (data, wallData, themeToApply, callback=()=>{}) =>{
    return (dispatch) =>{

        new HttpClient().post(SWITCH_THEME_UPDATE, data).then((response)=>{
            const { applyTheme } = response.data;
            if(applyTheme){
                changeTheme({wallData, themeToApply, dispatch}, callback, true);
            }else{
                dispatch(getWidgetWallData(null, data.wallId));
                setTimeout(()=> callback(),2000)
            }
        }).catch(ex=>{});
    }
}


export const changeTheme = (data, callback, isDisplay) => {
    const formData = new FormData();
    const { wallData, themeToApply, dispatch } = data;
    const { wallId, wallOwner, wall } = wallData;

    const personalization = wall.Personalization;
    if(personalization && Object.keys(personalization).length > 0){
        const personalizationId = personalization.id;
        formData.append('themeType', 2);
        formData.append('theme', themeToApply);
        formData.append('textDecorateStatus', personalization.textDecorateStatus);
        formData.append('postFeaturedStatus', personalization.postFeaturedStatus);
        formData.append('filterEnableStatus', personalization.filterEnableStatus);
        formData.append('textDecorate', personalization.textDecorate);
        formData.append('postFeatured', personalization.postFeatured);
        formData.append('filterStatus', personalization.filterStatus);
        formData.append('trimcontent', personalization.trimcontent);
        formData.append('trimContentStatus', personalization.trimContentStatus);
        formData.append('popupSlideShow', personalization.popupSlideShow);
        formData.append('popupSlideShowStatus', personalization.popupSlideShowStatus);
        formData.append('themeTypePre', personalization.autoScroll);
        formData.append('padding', personalization.padding);
        formData.append('ownerId', wallOwner);
        
        const apiCall = updateTheme(wallId, personalizationId, Object.fromEntries(formData));
        apiCall.then((response) => {
            const { responseCode } = response.data;
            if (responseCode == 200) {
                dispatch(getWidgetWallData(null, wallId));
                setTimeout(callback,2000)
            }
        }).catch((error) => {

        })
    }
}